module.exports = __webpack_public_path__ + "media/images/welcome_bg_day-57ab4e5097aba6bca628debe6851d249.png";